// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListGridCoverPhoto-displayGrid-B5xjF {
	display: grid;
	grid-template-columns: 50% 50%;
}

.ListGridCoverPhoto-firstImage-EzsRi {
	height: 500px;
    margin-right: 10px;
	border-radius: 12px 0px 0px 12px;
}

.ListGridCoverPhoto-secondImage-un5Ds {
	height: 270px;
    margin-bottom: 10px;
	border-radius: 0px 12px 0px 0px;
}

.ListGridCoverPhoto-thiredImage-fAkwh {
	height: 220px;
    margin-right: 5px;
}

.ListGridCoverPhoto-fouthImage-RoWDN {
	height: 220px;
    margin-left: 5px;
	border-radius: 0px 0px 12px 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/ListGridCoverPhoto/ListGridCoverPhoto.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,aAAa;IACV,kBAAkB;CACrB,gCAAgC;AACjC;;AAEA;CACC,aAAa;IACV,mBAAmB;CACtB,+BAA+B;AAChC;;AAEA;CACC,aAAa;IACV,iBAAiB;AACrB;;AAEA;CACC,aAAa;IACV,gBAAgB;CACnB,+BAA+B;AAChC","sourcesContent":[".displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n}\n\n.firstImage {\n\theight: 500px;\n    margin-right: 10px;\n\tborder-radius: 12px 0px 0px 12px;\n}\n\n.secondImage {\n\theight: 270px;\n    margin-bottom: 10px;\n\tborder-radius: 0px 12px 0px 0px;\n}\n\n.thiredImage {\n\theight: 220px;\n    margin-right: 5px;\n}\n\n.fouthImage {\n\theight: 220px;\n    margin-left: 5px;\n\tborder-radius: 0px 0px 12px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayGrid": `ListGridCoverPhoto-displayGrid-B5xjF`,
	"firstImage": `ListGridCoverPhoto-firstImage-EzsRi`,
	"secondImage": `ListGridCoverPhoto-secondImage-un5Ds`,
	"thiredImage": `ListGridCoverPhoto-thiredImage-fAkwh`,
	"fouthImage": `ListGridCoverPhoto-fouthImage-RoWDN`
};
module.exports = ___CSS_LOADER_EXPORT___;
